// Cloud env-var access. Centralised so every call site reads from the
// same place, fails the same way when vars are missing.

export function getWorkerUrl(): string | null {
  const v = import.meta.env.VITE_WORKER_URL;
  return v && v.length > 0 ? v : null;
}

export function getR2PublicUrl(): string | null {
  const v = import.meta.env.VITE_R2_PUBLIC_URL;
  return v && v.length > 0 ? v : null;
}

/** True iff all cloud plumbing (auth, worker, R2 custom domain) is
 *  configured. Call sites use this to hide cloud-only UI. */
export function isCloudConfigured(): boolean {
  return (
    !!import.meta.env.VITE_SUPABASE_URL &&
    !!import.meta.env.VITE_SUPABASE_ANON_KEY &&
    !!import.meta.env.VITE_WORKER_URL &&
    !!import.meta.env.VITE_R2_PUBLIC_URL
  );
}
